import React, { useState, useEffect } from 'react';
import env from '../../config';

const API_ROOT = env.backendUrl && env.backendUrl.endsWith('/api') ? env.backendUrl.replace(/\/$/, '') : `${env.backendUrl.replace(/\/$/, '')}/api`;
const API_URL = `${API_ROOT}/blockings`;

export default function Blockings() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ id: null, pessoa: '', objeto: '', periodo: '' });
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [error, setError] = useState(null);

  const today = (() => {
    const d = new Date();
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  })();

  useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAll = async () => {
    setLoading(true);
    try {
      const res = await fetch(API_URL, { headers: { Accept: 'application/json' } });
      const json = await res.json();
      setItems(Array.isArray(json) ? json : []);
    } catch (err) {
      console.error(err);
      setError('Erro ao carregar');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  };

  const startEdit = (it) => {
    setForm({ id: it.id, pessoa: it.pessoa || '', objeto: it.objeto || '', periodo: it.periodo || today });
    setEditing(true);
  };

  const cancel = () => {
    setForm({ id: null, pessoa: '', objeto: '', periodo: today });
    setEditing(false);
    setError(null);
  };

  const submit = async (e) => {
    e.preventDefault();
    try {
      const method = editing ? 'PUT' : 'POST';
      const url = editing ? `${API_URL}/${form.id}` : API_URL;
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error(await res.text());
      await fetchAll();
      cancel();
    } catch (err) {
      console.error(err);
      setError('Erro ao salvar');
    }
  };

  const remove = async (id) => {
    // eslint-disable-next-line no-restricted-globals
    if (!confirm('Confirmar exclusão?')) return;
    try {
      const res = await fetch(`${API_URL}/${id}`, { method: 'DELETE', headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error('Erro');
      setItems((s) => s.filter((x) => x.id !== id));
    } catch (err) {
      console.error(err);
      setError('Erro ao excluir');
    }
  };

  if (loading) return <div className="p-6 text-center">Carregando...</div>;

  return (
    <div className="container mx-auto p-4 md:p-8">
      <h1 className="text-2xl font-bold mb-4">Bloqueios (CRUD)</h1>

      <div className="bg-white p-4 rounded shadow mb-6">
        <h2 className="font-semibold mb-2">{editing ? 'Editar' : 'Novo'}</h2>
        {error && <div className="text-red-600 mb-2">{error}</div>}
        <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-4 gap-3">
          <input name="periodo" type="date" value={form.periodo} onChange={handleChange} className="p-2 border rounded" required />
          <select name="pessoa" value={form.pessoa} onChange={handleChange} className="p-2 border rounded" required>
            <option value="">Selecione pessoa</option>
            <option value="felipe">Felipe</option>
            <option value="miguel">Miguel</option>
          </select>
          <input name="objeto" type="text" value={form.objeto} onChange={handleChange} placeholder="Objeto" className="p-2 border rounded md:col-span-4" required />

          <div className="md:col-span-4 flex justify-end space-x-2 mt-2">
            {editing && <button type="button" onClick={cancel} className="px-4 py-2 bg-gray-200 rounded">Cancelar</button>}
            <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded">{editing ? 'Salvar' : 'Criar'}</button>
          </div>
        </form>
      </div>

      <div className="bg-white p-4 rounded shadow">
        <h2 className="font-semibold mb-2">Lista</h2>
        {items.length === 0 ? (
          <div className="text-gray-500">Nenhum bloqueio encontrado.</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-2 text-left text-xs text-gray-500">ID</th>
                  <th className="px-4 py-2 text-left text-xs text-gray-500">Periodo</th>
                  <th className="px-4 py-2 text-left text-xs text-gray-500">Pessoa</th>
                  <th className="px-4 py-2 text-left text-xs text-gray-500">Objeto</th>
                  <th className="px-4 py-2 text-right text-xs text-gray-500">Ações</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-100">
                {items.map((it) => (
                  <tr key={it.id} className="hover:bg-gray-50">
                    <td className="px-4 py-2 text-sm">{it.id}</td>
                    <td className="px-4 py-2 text-sm">{it.periodo}</td>
                    <td className="px-4 py-2 text-sm">{it.pessoa}</td>
                    <td className="px-4 py-2 text-sm max-w-xs truncate">{it.objeto}</td>
                    <td className="px-4 py-2 text-sm text-right">
                      <button onClick={() => startEdit(it)} className="text-indigo-600 mr-3">Editar</button>
                      <button onClick={() => remove(it.id)} className="text-red-600">Excluir</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
